import Vue from "vue";
// vee-validate by benQ
import VeeValidate, { Validator } from "vee-validate";
import { dictionary, getFieldLabel } from "veeValidate";
import { regexObj } from "src/assets/js/common/veeValidate";
import { getLanguage } from "src/lang";
import { numeric } from "@vee-validate/rules";
import moment from "moment";

Validator.extend("formatNumeric", {
  getMessage(field) {
    return `Incorrect ${getFieldLabel(field)} format`;
  },
  validate: (val) => {
    return numeric(val);
  },
});

Validator.extend("phoneNumber", {
  getMessage: (field) => "Invalid phone number",
  validate: (value) => regexObj.isPhoneNumber.test(value),
});

Validator.extend("isFloat", {
  getMessage: (field) => `Invalid ${getFieldLabel(field)}`,
  validate: (value) => regexObj.isFloat.test(value),
});

Validator.extend("isTHPlateNo", {
  getMessage: (field) => `Invalid ${getFieldLabel(field)}`,
  validate: (value) => regexObj.isTHPlateNo.test(value),
});

Validator.extend("valid-thai-language", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)} Thai`;
  },
  validate: (val) => {
    var re = new RegExp(
      "^([/]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$",
      "g"
    );
    return re.test(val);
  },
});
Validator.extend("valid-thai-postalcode", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp("^([0-9]{5})+$", "g");
    return re.test(val);
  },
});

Validator.extend("valid-special-character", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp("^[^/,]*$");
    return re.test(val);
  },
});

// Allow Special Character, Thai-Eng lang, Number
Validator.extend("commonInput", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp(
      /^([-!$%^&*()_+|~=`{}[:;<>?,.@#'\"]|[a-zA-Z0-9]|[/]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$/,
      "g"
    );
    return re.test(val) ? true : false;
  },
});

// Just like the above rule but add "]" and change error message 
Validator.extend("extendCommonInput", {
  getMessage(field) {
    return `Incorrect ${getFieldLabel(field)} format`;
  },
  validate: (val) => {
    var re = new RegExp(
      /^([-!$%^&*()_+|~=`{}[:;<>?,.@#'\"\]]|[a-zA-Z0-9]|[/]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$/,
      "g"
    );
    return re.test(val) ? true : false;
  },
});

// textThaiAndEng allow input TH/EN language, Special Character
Validator.extend("textThaiAndEng", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp(
      /^([a-zA-Z]|[/]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$/,
      "g"
    );
    return re.test(val);
  },
});

// exceptSpecialCharactersv1 allow input TH/EN language, Special Character, Number except , and /
Validator.extend("exceptSpecialCharactersv1", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp(
      /^([-!$%^&*()_+|~=`{}[:;<>?.@#'\"]|[a-zA-Z0-9]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$/,
      "g"
    );
    return re.test(val);
  },
});
// exceptSpecialCharactersv1 allow input TH/EN language, Special Character, Number except /
Validator.extend("exceptSpecialCharactersv2", {
  getMessage(field) {
    return `Invalid ${getFieldLabel(field)}`;
  },
  validate: (val) => {
    var re = new RegExp(
      /^([-!$%^&*()_+|~=`{}[:;<>?,.@#'\"]|[a-zA-Z0-9]|[\\]|[ ]|[\n]|[.]|[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ])+$/,
      "g"
    );
    return re.test(val);
  },
});
Validator.extend("personName", {
  getMessage: (field) => `Invalid ${getFieldLabel(field)}`,
  validate: (value) =>
    regexObj.isPersonName.test(value) && regexObj.isNotNumber.test(value),
});
Validator.extend("driverName", {
  getMessage: (field) => `Invalid ${getFieldLabel(field)}`,
  validate: (value) =>
    regexObj.isNonDigitDriverName.test(value),
});

Validator.extend("driverLicenseNumber", {
  getMessage: (field) => `Invalid ${getFieldLabel(field)}`,
  validate: (value) => regexObj.isDriverLicenseNumber.test(value),
});

Validator.extend("enOnly", {
  getMessage: () => "Input EN only",
  validate: (value) => regexObj.isEnChar.test(value),
});

// 同时引入了vee-validate和elementUI插件,他们的计算属性fields冲突了所以加如下配置
Validator.extend("cusMax", {
  getMessage: (field, val) =>
    `The ${field} field may not be greater than ${val} characters.`,
  validate: (value, max) => {
    return Number(max[0]) >= value.length;
  },
});
Validator.extend("maxRemark", {
  validate: (value, max) => {
    return Number(max[0]) >= value.length;
  },
});
Validator.extend("cusNumeric", {
  getMessage: (field) =>
    `The ${field} field may only contain numberic characters.`,
  validate: (value) => regexObj.isNumber.test(value),
});
Validator.extend("cusBetween", {
  getMessage: (field, between) =>
    `${field} must be between ${between[0]} and ${between[1]}`,
  validate: (value, between) => {
    const min = between[0];
    const max = between[1];
    return Number(min) <= value && Number(max) >= value;
  },
});
Validator.extend("cusMax2", {
  getMessage: (field, val) => `Max value is ${val}`,
  validate: (value, max) => {
    return Number(max[0]) >= value;
  },
});
Validator.extend("cusMin2", {
  getMessage: (field, val) => `Minimum value is ${val}`,
  validate: (value, min) => {
    return Number(min[0]) <= value;
  },
});
Validator.extend("cusMax3", {
  getMessage: (field) => `${field} is over maximum limit`,
  validate: (value, max) => {
    return Number(max[0]) >= value;
  },
});

Validator.extend("max_character", {
  getMessage: (field) => `${field} is over maximum limit`,
  validate: (value, max) => {
    return value && value.length <= Number(max[0]);
  },
});

Validator.extend("cusMin3", {
  getMessage: (field, val) => `${field} Minimum should be more than ${val}`,
  validate: (value, min) => {
    return Number(min[0]) <= value;
  },
});
Validator.extend("validateRangeTime", {
  getMessage: (field) => {
    // show only errror shipping create range time
    if (field.includes("Target Delivery Time")) {
      return `Target Delivery Time must be greater than Target Pick Up Time`;
    } else {
      return `Date Time 2 must be greater than Date Time 1`;
    }
  },
  validate: (value) => {
    return false;
  },
});
Validator.extend("validateRangeTemperatureUpperLimit", {
  getMessage: (field) => {
    return "Upper limit must be greater than Lower limit";
  },
  validate: (value) => {
    return false;
  },
});

Validator.extend("validateTemperatureLowerLimit", {
  getMessage: (field) => {
    return "Lower limit must be less than Upper limit";
  },
  validate: (value) => {
    return false;
  },
});

Validator.extend("onlyNumber", {
  validate: (value) => {
    return true;
  },
});

Validator.extend("item_number_min_value", {
  getMessage(field) {
    return `Incorrect ${getFieldLabel(field)} format`;
  },
  validate: (val, args) => {
    return numeric(val) && parseInt(val, 10) >= args;
  },
});

Validator.extend("twoNumberDigits", {
  validate: (value) => {
    // value have to match 2 digits and can be start with 0
    return regexObj.isTwoDigitsNumber.test(value);
  },
  getMessage(field, params, data) {
    return "Code must be 2 digits";
  }
});


Validator.extend("temperatureCodeRange", {
  validate: (value) => {

    try {
      const valueNumber = Number(value);
      console.log(valueNumber)
      // value have to match 2 digits and can be start with 0
      return valueNumber >= 1 && valueNumber <= 99;
    }catch (e) {
      return false;
    }
  },
  getMessage(field, params, data) {
    return "Please enter a number between 01 and 99";
  }
})

Validator.extend(
  "isAfterPickupDateFrom",
  {
    validate: (value, args) => {
      if(!args[0] || !value[0]) return true;

      const pickupDate = moment(args[0]);
      const deliveryDate = moment(value[0]);

      return deliveryDate.isSameOrAfter(pickupDate, 'day');
    },
    getMessage(field, params, data) {
      return "Target Delivery Date (From) should be the same date as Target Pick Up Date (From) or onward";
    },
  }
);

// validate target delivery must after target pickup atleast 1 second 
Validator.extend(
  "isAfterPickupTimeFrom",
  {
    validate: (value, args) => {
      if(!args[0] || !value[0]) return true;

      const pickupTime = moment(args[0]);
      const deliveryTime = moment(value[0]);

      return deliveryTime.isAfter(pickupTime, 'second');
    },
    getMessage(field, params, data) {
      return "Target Delivery Time (From) should be later than Target Pick Up Time (From)";
    },
  }
);

Validator.extend(
  "isAfterPickupTimeTo",
  {
    validate: (value, args) => {
      if(!args[0] || !value[1]) return true;

      const pickupTime = moment(args[0]);
      const deliveryTime = moment(value[1]);

      return deliveryTime.isAfter(pickupTime, 'second');
    },
    getMessage(field, params, data) {
      return "Target Delivery Time (To) should be later than Target Pick Up Time(To)";
    },
  }
);

Validator.extend(
  "isAfterPickupDateTo",
  {
    validate: (value, args) => {
      if(!args[0] || !value[1]) return true;

      const pickupDate = moment(args[0]);
      const deliveryDate = moment(value[1]);

      return deliveryDate.isSameOrAfter(pickupDate, 'day');
    },
    getMessage(field, params, data) {
      return "Target Delivery Date (To) should be the same date as Target Pick Up Date (To) or onward";
    },
  }
);

Validator.extend(
  "isTargetAfterNow",
  {
    validate: (value, args) => {
      if(!value) return true;

      const isTimeFromAfterNow = moment(value[0]).isSameOrAfter(moment(), 'second');
      const isTimeFromToNow = moment(value[1]).isSameOrAfter(moment(), 'second');

      return isTimeFromAfterNow && isTimeFromToNow;
    },
    getMessage(field, params, data) {
      if(field.toLowerCase().includes('pickup')) return "Target Pick Up Time cannot be past time";
      if(field.toLowerCase().includes('delivery')) return "Target Delivery Time cannot be past time";
    },
  }
);

const config = {
  fieldsBagName: "veefields",
  locale: getLanguage() || "en",
  dictionary,
};
Vue.use(VeeValidate, config);



// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js